/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodBankAssociation from './blood-bank-association';
import BloodBankAssociationDetail from './blood-bank-association-detail';
import BloodBankAssociationUpdate from './blood-bank-association-update';
import BloodBankAssociationDeleteDialog from './blood-bank-association-delete-dialog';

const BloodBankAssociationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodBankAssociation />} />
    <Route path="new" element={<BloodBankAssociationUpdate />} />
    <Route path=":id">
      <Route index element={<BloodBankAssociationDetail />} />
      <Route path="edit" element={<BloodBankAssociationUpdate />} />
      <Route path="delete" element={<BloodBankAssociationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodBankAssociationRoutes;
